import { Box } from "@mui/material";
import * as React from "react";
import logoPortnet from "../../../asset/images/portnet-logo.png";
import {
  PTButton,
  PTIcon,
  PTNotificationIcon,
  PTTranslate,
  PTTypography,
} from "../../components/ui";
import { useDialog } from "../../hooks";
import { useAuth } from "../../provider";
import { getPrivateRoutes } from "../../router/privateRoutes";
import { NAVCODE, USER_ROLES, USER_STATUS_CODE } from "../../types";
import JWtUtils from "../../utils/JWtUtils";

export const LeftBar = ({
  user,
  isMidium,
  isMobile,
  handleClick,
  toggleLeftBar,
  ...otherProps
}) => {
  const { logout } = useAuth();
  const { showDialog } = useDialog();
  const leftBarStyle = {
    width: "18vw",
    height: "calc(100vh - 28px - 28px - 4px)",
    marginLeft: "22px",
    backgroundColor: "#1F1E30",
    borderRadius: "10px",
    paddingLeft: "14.38px",
    paddingTop: "19.18px",
    //scrollY: "auto",
    overflow: "auto",
    ...(isMidium && { width: "33vw" }),
    ...(isMobile && { width: "100%", height: "100%", marginLeft: "0px" }),
  };
  const handelLogOut = () => {
    showDialog(
      {
        title: "logout_action",
        description: "logout_description",
      },
      () => {
        logout();
      },
      () => {
        // do nothing
      }
    );
  };
  return (
    <Box sx={leftBarStyle}>
      <img
        src={logoPortnet}
        alt="Logo"
        style={{
          display: "block",
          width: "134.02px",
          height: "38.36px",
          margin: "auto",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
          marginTop: "39px",
        }}
      >
        <PTTypography variant="h6" sx={{ color: "#FFFFFF" }}>
          dashboard
        </PTTypography>
        <UserInfo {...user} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "39px",
            width: "94%",
            justifyContent: "flex-start",
            marginLeft: "-20px",
            maxHeight: "calc(100vh - 350px)",
          }}
        >
          {getPrivateRoutes()
            .filter((r) => !r.isHidden?.(user?.statusCode))
            .filter((r) => r.nav.includes(NAVCODE.LEFT))
            .filter((r) => JWtUtils.hasAnyRole(r.roles))
            .sort((a, b) => a.order - b.order)
            .map((r) => {
              return (
                <PTButton
                  key={r.key}
                  title={r.label}
                  startIcon={<PTIcon icon={r.icon} color={"#000000"} />}
                  variant="contained"
                  sx={{
                    width: "100%",
                    height: "40px",
                    justifyContent: "flex-start",
                    padding: "0 10px",
                    borderRadius: "8px",
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "#25384a",
                      color: "#FFFFFF",
                    },
                  }}
                  sxAdjust={{ justifyContent: "space-between" }}
                  onClick={() => {
                    handleClick(r);
                  }}
                />
              );
            })}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            marginTop: "60px",
            pb: "20px",
            gap: "6px",
          }}
        >
          <PTIcon
            icon="grid"
            tooltip="grid"
            color={"#FFFFFF"}
            onClick={toggleLeftBar}
            sx={{
              cursor: "pointer",
              "&:hover": {
                color: "#25384a",
              },
            }}
          />
          <PTNotificationIcon />
          <PTIcon
            icon="logout"
            tooltip="logout"
            color={"#FFFFFF"}
            sx={{
              cursor: "pointer",
              "&:hover": {
                color: "#25384a",
              },
            }}
            onClick={handelLogOut}
          />
        </Box>
      </Box>
    </Box>
  );
};

const UserInfo = (user) => {
  const roles = localStorage.getItem("roles");
  if (
    JWtUtils.hasAnyRole([USER_ROLES.MANUFACTURER]) &&
    user?.statusCode !== USER_STATUS_CODE.ACTIVE
  ) {
    return (
      <PTTypography variant="body3" sx={{ color: "#FF725E" }}>
        userIncoplete
      </PTTypography>
    );
  }

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      mt: "5px",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <PTTypography variant="body1" sx={{ color: "#FFFFFF" }}>
        {user?.firstName} {user?.lastName}
      </PTTypography>
      <PTTypography variant="body2" sx={{ color: "#FFFFFF" }}>
        <PTTranslate tk={roles} />
      </PTTypography>
      <PTTypography variant="body3" sx={{ color: "#FFFFFF" }}>
        {user.company}
      </PTTypography>
    </Box>
  );
};
export default LeftBar;
